// extracted by mini-css-extract-plugin
export var container = "_98-0";
export var fallback = "_98-5";
export var fallbackIcon = "_98-6";
export var hidden = "_98-2";
export var image = "_98-3";
export var loaded = "_98-4";
export var placeholder = "_98-1";